import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

export const FormTextField = ({ name, control, label, rules, defaultValue="", ...other }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({
        field: { onChange, value },
        fieldState: { error },
        formState,
      }) => (
        <TextField
          required={rules && rules.required}
          style={{'marginTop': 20}}
          helperText={error ? error.message : null}
          size="small"
          error={!!error}
          onChange={onChange}
          fullWidth
          label={label}
          variant="outlined"
          value={value}
          {...other}
        />
      )}
    />
  );
};